import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from 'app/shared/directives/click-outside/click-outside.directive';

@NgModule({
  declarations: [ClickOutsideDirective],
  exports: [ClickOutsideDirective],
})
export class ClickOutsideModule {}
